import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "contacto",
  class: "relative scroll-mt-20 overflow-hidden py-28 md:py-36"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pointer-events-none absolute bottom-0 left-1/2 h-[500px] w-[1000px] -translate-x-1/2 translate-y-1/2 rounded-full bg-ember/20 blur-3xl" }, null, -1)
const _hoisted_3 = { class: "relative grid gap-14 lg:grid-cols-2 lg:gap-20" }
const _hoisted_4 = { class: "eyebrow" }
const _hoisted_5 = { class: "section-title mt-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-molten" }, "próxima pieza", -1)
const _hoisted_7 = { class: "mt-6 max-w-md text-ivory/50" }
const _hoisted_8 = { class: "mt-12 space-y-5" }
const _hoisted_9 = {
  href: "tel:+525574674901",
  class: "group flex items-center gap-5 rounded-2xl border border-copper/10 bg-smoke/60 p-5 transition-all hover:border-copper/50 hover:bg-smoke"
}
const _hoisted_10 = { class: "flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-copper-light to-copper-deep text-ink transition-transform group-hover:scale-110 group-hover:rotate-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "block text-xs uppercase tracking-[0.2em] text-ivory/40" }, "Teléfono"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-lg text-ivory group-hover:text-copper-light" }, "+52 55 7467 4901")
], -1)
const _hoisted_12 = {
  href: "mailto:administracion@imperiodemetal.com.mx",
  class: "group flex items-center gap-5 rounded-2xl border border-copper/10 bg-smoke/60 p-5 transition-all hover:border-copper/50 hover:bg-smoke"
}
const _hoisted_13 = { class: "flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-copper-light to-copper-deep text-ink transition-transform group-hover:scale-110 group-hover:rotate-12" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "min-w-0" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "block text-xs uppercase tracking-[0.2em] text-ivory/40" }, "Correo"),
  /*#__PURE__*/_createElementVNode("span", { class: "block break-all text-lg text-ivory group-hover:text-copper-light" }, " administracion@imperiodemetal.com.mx ")
], -1)
const _hoisted_15 = { class: "relative rounded-3xl bg-gradient-to-br from-copper/40 via-copper/5 to-ember/40 p-px" }
const _hoisted_16 = { class: "rounded-3xl bg-char/95 p-7 backdrop-blur-xl sm:p-10" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-8 font-display text-2xl text-ivory" }, "Escríbenos", -1)

import ContactForm from "@/components/base/ContactForm.vue";
import ContainerComponent from "@/components/base/ContainerComponent.vue";
import EmberCanvas from "@/components/base/EmberCanvas.vue";
import Call from "@vicons/ionicons5/Call";
import Mail from "@vicons/ionicons5/Mail";

export default /*#__PURE__*/_defineComponent({
  __name: 'ContactComponent',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _directive_reveal = _resolveDirective("reveal")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode(EmberCanvas, { density: 40 }),
    _createVNode(ContainerComponent, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_4, [
              _createTextVNode("Contacto")
            ])), [
              [_directive_reveal]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("h2", _hoisted_5, [
              _createTextVNode(" Forjemos juntos tu "),
              _hoisted_6
            ])), [
              [_directive_reveal, 100]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_7, [
              _createTextVNode(" Cuéntanos tu idea: una medalla, un trofeo, una escultura o un proyecto que aún no tiene nombre. Te respondemos con una propuesta a la medida. ")
            ])), [
              [_directive_reveal, 200]
            ]),
            _createElementVNode("ul", _hoisted_8, [
              _withDirectives((_openBlock(), _createElementBlock("li", null, [
                _createElementVNode("a", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, [
                    _createVNode(_unref(Call), { class: "w-5" })
                  ]),
                  _hoisted_11
                ])
              ])), [
                [
                  _directive_reveal,
                  300,
                  void 0,
                  { left: true }
                ]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("li", null, [
                _createElementVNode("a", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, [
                    _createVNode(_unref(Mail), { class: "w-5" })
                  ]),
                  _hoisted_14
                ])
              ])), [
                [
                  _directive_reveal,
                  400,
                  void 0,
                  { left: true }
                ]
              ])
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(ContactForm)
            ])
          ])), [
            [
              _directive_reveal,
              200,
              void 0,
              { right: true }
            ]
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})